import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgOilCleanserGlyph from './svgs/OilCleanserGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var oilCleanserGlyph = (props => useIcon(SvgOilCleanserGlyph, SvgOilCleanserGlyph, props));

export { oilCleanserGlyph as default };
